import ReactTooltip from 'react-tooltip';
import { useState } from 'react';

// ReactTooltip は React v18 に未対応のため useState() や setTimeout を使った回避策で実装
// 参考）https://github.com/wwayne/react-tooltip/issues/769#issuecomment-1119127882
function BaseFieldTooltip(props) {
  const [tooltip, showTooltip] = useState(true);
  const tooltipText = `「全国」かつ「大学／短大／専門学校進学者」<br />を選択しているときに各分野を選択できます。`
  return (
    <>
      { props.isActive && tooltip && <ReactTooltip className="!bg-gray-600 !p-1 xl:!p-2 !text-2xs xl:!text-xs" effect="solid" multiline={true} />}
      <div
        data-tip={tooltipText}
        onMouseEnter={() => showTooltip(true)}
        onMouseLeave={() => {
          showTooltip(false);
          setTimeout(() => showTooltip(true), 50);
        }}
      >
        { props.children }
      </div>
    </>
  )
}

export default BaseFieldTooltip;
